import { render, staticRenderFns } from "./developerList.vue?vue&type=template&id=3820dae3&scoped=true&"
import script from "./developerList.vue?vue&type=script&lang=js&"
export * from "./developerList.vue?vue&type=script&lang=js&"
import style0 from "./developerList.vue?vue&type=style&index=0&id=3820dae3&prod&lang=css&"
import style1 from "./developerList.vue?vue&type=style&index=1&id=3820dae3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820dae3",
  null
  
)

export default component.exports